import config from '../../config';
import { authHeader } from '../../helpers';

export const bulletinService = {
  getBulletins
};

function getBulletins() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/bulletins`, requestOptions).then(handleResponse);
}

async function handleResponse(response) {
  const text = await response.text();
  const data = text && JSON.parse(text);

  if (!response.ok) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      // logout();
      //location.reload(true);
    }
    throw new Error(data && data.message || response.statusText);
  }
  return data;
}
